export enum LandedCostProvider {
  ZONOS = "ZONOS",
}

export enum LandedCostSource {
  REDO_COMMIT = "REDO_COMMIT",
  MERCHANT_CHECKOUT = "MERCHANT_CHECKOUT",
}
